export default {
  computed: {
    siteColors() {
      return this.$vuetify.theme.themes.light;
    }
  }
};
